<template>
  <div class="sticky-cta" id="sticky-cta">
    <button type="button" class="btn-primary" data-open-signup>Kostenlos registrieren <span class="arrow">→</span></button>
  </div>
</template>

<script>
export default {
  name: 'KennenlernenStickyCta',
};
</script>
